import PropTypes from 'prop-types';
import React from 'react';
import Link from 'next/link';
import { useTranslations, useLocale } from 'next-intl';
import MixedCopy from '@components/molecules/mixed-copy/mixedCopy';
import stripHtmlTags from '@helper/stripHtmlTags';
import Headline from '../../atoms/headline/headline';

import StyledDateTeaser from './dateTeaser.style';

const DateTeaser = props => {
  const { uri, headline, copy, startDate, endDate, seats = 0, divider = true } = props;
  const t = useTranslations();
  const locale = useLocale();

  const hasTime = startDate && endDate && startDate.H && startDate.i && endDate.H && endDate.i;

  const formatStartDate = new Date(startDate.c);
  const formatEndDate = new Date(endDate.c);

  return (
    <StyledDateTeaser {...props} divider={divider}>
      <Link
        href={{
          pathname: '/universal',
          query: { uri }
        }}
        as={uri}
      >
        <div className="dateTeaser__link">
          <div className="dateTeaser_capacity">
            <p className="dateTeaser__capacityLabel">
              {seats > 0 ? t('calendar.seatsLeft') : t('calendar.soldOut')}
            </p>
            <span className="dateTeaser__divider" />
          </div>

          <div className="dateTeaser__wrapper">
            {hasTime && (
              <div className="dateTeaser__time" dateTime={formatStartDate.toLocaleString()}>
                <span>
                  {`${formatStartDate.getHours()}:${
                    (formatStartDate.getMinutes() < 10 ? '0' : '') + formatStartDate.getMinutes()
                  }`}{' '}
                  {locale === 'de' ? 'Uhr' : ''}
                </span>{' '}
                {startDate.c !== endDate.c && (
                  <>
                    –
                    <span>
                      {` ${formatEndDate.getHours()}:${
                        (formatEndDate.getMinutes() < 10 ? '0' : '') + formatEndDate.getMinutes()
                      } ${locale === 'de' ? 'Uhr' : ''}`}
                    </span>
                  </>
                )}
              </div>
            )}
            <Headline className="dateTeaser__headline" listTeaser>
              {headline}
            </Headline>
            {copy ? (
              <MixedCopy
                className="dateTeaser__copy"
                fullWidth
                html={
                  stripHtmlTags(copy).length > 140
                    ? `${stripHtmlTags(copy).substring(0, 140)}...`
                    : stripHtmlTags(copy)
                }
              />
            ) : null}
          </div>
          <div className="dateTeaser__ctaWrapper">
            <Link href={uri} title="Mehr details" className="dateTeaser__ctaMore">
              {t('calendar.moreDetails')}
            </Link>
          </div>
        </div>
      </Link>
    </StyledDateTeaser>
  );
};

DateTeaser.propTypes = {
  slug: PropTypes.string.isRequired,
  uri: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  copy: PropTypes.string,
  startDate: PropTypes.shape({
    d: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    m: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    y: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    H: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    i: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    c: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  endDate: PropTypes.shape({
    d: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    m: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    y: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    H: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    i: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    c: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  divider: PropTypes.bool,
  seats: PropTypes.number,
  bookable: PropTypes.bool
};

export default DateTeaser;
